"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteGeographyFlag = void 0;
var RouteGeographyFlag;
(function (RouteGeographyFlag) {
    RouteGeographyFlag[RouteGeographyFlag["isAsian"] = 0] = "isAsian";
    RouteGeographyFlag[RouteGeographyFlag["isEnglishSpeaking"] = 1] = "isEnglishSpeaking";
    RouteGeographyFlag[RouteGeographyFlag["isMexican"] = 2] = "isMexican";
    RouteGeographyFlag[RouteGeographyFlag["isSuvReplacingLuxurySedan"] = 3] = "isSuvReplacingLuxurySedan";
    RouteGeographyFlag[RouteGeographyFlag["isCuba"] = 4] = "isCuba";
    RouteGeographyFlag[RouteGeographyFlag["isBahamas"] = 5] = "isBahamas";
})(RouteGeographyFlag || (exports.RouteGeographyFlag = RouteGeographyFlag = {}));
//# sourceMappingURL=RouteGeographyFlag.js.map